import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageModel, ImageModelSchema } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetSweetShopServiceApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        title: z.string(),
        description: z.any().optional().nullable(),
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
    }),
});

type GetSweetShopServiceApiResponse
    = ApiResponse<z.infer<typeof GetSweetShopServiceApiResponseSchema>>;

type GetSweetShopServiceActionRequest = undefined

export const getSweetShopService = createAsyncThunk<
    GetSweetShopServiceApiResponse | BaseError,
    GetSweetShopServiceActionRequest
>(
    'SweetShopPageActionsGetSweetShopService',
    async () => apiInstance.get(
        '/sweet-shop-service',
        {
            'populate[image][fields]': 'url',
        },
        GetSweetShopServiceApiResponseSchema,
    ),
);

export const GetSweetShopServiceActionResponseMapper = {
    getImage: (
        { data }: GetSweetShopServiceApiResponse,
    ): ImageModel => ImageModelSchema.parse({
        url: data.data.image?.url,
    }),

    getTitle: (
        { data }: GetSweetShopServiceApiResponse,
    ): string => data.data.title,

    getDescription: (
        { data }: GetSweetShopServiceApiResponse,
    ): any => data.data.description,
};
